export default "__VITE_ASSET__DTmN_TEP__"